export const chatbot = {
   p1: `أعِدّ مساعدك الافتراضي`,
   p2: `فعّل خدمة روبوت المحادثة للرد تلقائيًا على أكثر أسئلة نزلائك شيوعًا.`,
   p3: `أعِدّ مساعدك الافتراضي. خصّص ردود روبوت المحادثة لتقديم معلومات سريعة ودقيقة إلى نزلائك، وحلّ استفساراتهم الأكثر تكرارًا تلقائيًا.`,
   p4: `إعداد`,
   p5: `تم تفعيل المساعد الافتراضي بنجاح`,
   p6: `تم إيقاف المساعد الافتراضي`,

   p7: `إعداد ردود روبوت المحادثة`,
   p8: `وحدة الإقامة المسنَدة:`,
   p9: `خصّص الردود التلقائية لروبوت المحادثة لمعالجة أسئلة نزلائك الأكثر تكرارًا بكفاءة.`,

   p10: `لديك تغييرات غير محفوظة. هل تريد تجاهلها والانتقال إلى سؤال آخر؟`,

   p11: `السؤال:`,
   p12: `أدرِج صورة في ردّك`,
   p13: `رفع صورة`,
   p14: `حذف الصورة`,
   p15: `حفظ الرد`,
   p16: `تم حفظ الرد بنجاح`,
   p17: `حدث خطأ أثناء حفظ الرد.`,

   p18: `حدث خطأ أثناء محاولة حذف الصورة.`,
   p19: `اكتب ردّك...`,

   p20: `كتلة الرد`,
   p21: `معاينة`,
   p22: ``,
   p23: ``,
   p24: ``,
   p25: ``,
   p26: ``,
   p27: ``,
   p28: ``,
   p29: ``,
   p30: ``,
}
